import { render, staticRenderFns } from "./paypalForm.vue?vue&type=template&id=b9d56f52"
import script from "./paypalForm.vue?vue&type=script&lang=js"
export * from "./paypalForm.vue?vue&type=script&lang=js"
import style0 from "./paypalForm.vue?vue&type=style&index=0&id=b9d56f52&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports